import { render } from "./ResourcesPanel.vue?vue&type=template&id=fbe0c74e&ts=true"
import script from "./ResourcesPanel.vue?vue&type=script&lang=ts"
export * from "./ResourcesPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__